import { render, staticRenderFns } from "./GeneratedProductsList.vue?vue&type=template&id=9f587a00&scoped=true"
import script from "./GeneratedProductsList.vue?vue&type=script&lang=js"
export * from "./GeneratedProductsList.vue?vue&type=script&lang=js"
import style0 from "./GeneratedProductsList.vue?vue&type=style&index=0&id=9f587a00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f587a00",
  null
  
)

export default component.exports